import {IComponentOptions} from 'angular';
import {DecadalTableController} from './decadal-discharge-table.controller';

const template = require<string>('./decadal-discharge-table.html');
const decadalTableComponent: IComponentOptions = {
  bindings: {
    decadalData: '<'
  },
  controller: DecadalTableController,
  template
};
export default decadalTableComponent;



/** WEBPACK FOOTER **
 ** ./app/operational/journal/decadal-discharge-table.component.ts
 **/